module.exports = __webpack_public_path__ + "static/media/thumbnail2.dee4eefe.png";